module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label i18n-label=\"Archived Documents\"></app-widgets-label> <app-widgets-archived-document-list ng-model=route.documents read-only=true></app-widgets-archived-document-list> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/general/partial_archive.html
// module id = 502
// module chunks = 0